module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('fieldset', {
    attrs: {
      "disabled": !_vm.isEditable
    }
  }, [_c('div', {
    staticClass: "col-md-12 mb-20"
  }, [_c('h3', {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm.$t('organization.pickOrganization')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 text-right mt-10"
  }, [(_vm.userOrganization) ? _c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'my_organization'
    }
  }, [_c('h4', {
    staticClass: "mt-0"
  }, [_vm._v(_vm._s(_vm.userOrganization.name))]), _vm._v(" "), (_vm.userOrganization.status === 'approved') ? _c('checkbox', {
    attrs: {
      "checked": _vm.project.organization_id === _vm.userOrganization.id
    },
    on: {
      "change": function($event) {
        return _vm.pickUserOrganization()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('project.form.createForMyOrganization')))])]) : _c('div', [_vm._v(_vm._s(_vm.$t('project.form.organizationNotConfirmed')))])], 1) : _c('div', [_c('h4', {
    staticClass: "user-link--yellow mt-15"
  }, [_c('router-link', {
    attrs: {
      "to": "/profile/edit#organization"
    }
  }, [_vm._v(_vm._s(_vm.$t('project.form.createOrganization')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('h3', {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm.$t('or')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mt-10"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('project.form.pickOrganization')))]), _vm._v(" "), _c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'organization'
    }
  }, [_c('multiselect', {
    staticClass: "rais",
    attrs: {
      "options": _vm.organizations,
      "track-by": "id",
      "label": "name",
      "placeholder": _vm.$t('organization.organization'),
      "showLabels": false
    },
    on: {
      "select": _vm.selectOrganization,
      "remove": function($event) {
        _vm.project.organization_id = null
      }
    },
    model: {
      value: (_vm.organization),
      callback: function($$v) {
        _vm.organization = $$v
      },
      expression: "organization"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(_vm._s(_vm.$t('noResults')))])])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b78cf9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Form/ChooseOrganization.vue
// module id = 821
// module chunks = 1